import { memo } from 'react';
import classNames from 'classnames';

import { NavDropdownHeaderIsEmptyFn, NavDropdownHeaderProps } from './nav-dropdown-header.config';
import { TitleV2 } from '../../titlev2/titlev2.component';
import { Text } from '../../text/text.component';
import { Button } from '../../button/button.component';

const NavDropdownHeader = memo(
  ({
    additionalClasses,
    title,
    description,
    button,
    propertiesId,
    propertiesLabel,
    propertiesRole,
    ...props
  }: NavDropdownHeaderProps) => {
    return !NavDropdownHeaderIsEmptyFn({ button, title, description, ...props }) ? (
      <div
        id={propertiesId}
        aria-label={propertiesLabel}
        role={propertiesRole}
        className={classNames('snowflake-mega-nav-dropdown-header', additionalClasses)}
        data-testid="snowflake-mega-nav-dropdown-header"
      >
        <div className="snowflake-mega-nav-dropdown-header-content">
          <div className="snowflake-mega-nav-dropdown-header-content-left">
            <TitleV2 tabIndex={0} {...title} variantClassName="heading-3-v2" type="span" />
            <Text tabIndex={0} additionalClasses="snowflake-mega-nav-dropdown-header-content-text" {...description} />
          </div>
          <div className="snowflake-mega-nav-dropdown-header-content-right snowflake-button-secondary snowflake-button-blue snowflake-button-compact">
            <Button {...button} />
          </div>
        </div>
        <div className="snowflake-mega-nav-dropdown-header-divider" />
      </div>
    ) : null;
  }
);

NavDropdownHeader.displayName = 'NavDropdownHeader';

export default NavDropdownHeader;
